<div class="bh">
    <div class="bh-sort" (click)="customSort()" *ngIf="dataList.length > 1">
        <i [ngClass]="isAsc ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down'"></i> Sort
    </div>

    <p-accordion [multiple]="true">
        <p-accordionTab *ngFor="let item1 of dataList">
            <ng-template pTemplate="header">
                <span class="bh-acc-header">
                    <i class="pi pi-file"></i>
                    <span class="bh-acc-date">{{ item1.dateTime | date : "short" }}</span>
                    <span class="bh-acc-sep">·</span>
                    <span class="bh-acc-inv">Invoice #{{ item1.invoiceNo }}</span>
                </span>
            </ng-template>

            <div class="bh-body">
                <div class="bh-grid">
                    <div class="bh-tile">
                        <span class="bh-tile-label"><i class="pi pi-calendar"></i> Dated</span>
                        <span class="bh-tile-value">{{ item1.dateTime | date : "short" }}</span>
                    </div>
                    <div class="bh-tile">
                        <span class="bh-tile-label"><i class="pi pi-hashtag"></i> Invoice #</span>
                        <span class="bh-tile-value">{{ item1.invoiceNo }}</span>
                    </div>
                    <div class="bh-tile">
                        <span class="bh-tile-label"><i class="pi pi-tag"></i> Invoice Type</span>
                        <span class="bh-tile-value">{{ item1.invoiceTypeString }}</span>
                    </div>
                    <div class="bh-tile">
                        <span class="bh-tile-label"><i class="pi pi-ticket"></i> Applied Coupon</span>
                        <span class="bh-tile-value">{{ item1?.couponCode ? item1.couponCode : "N/A" }}</span>
                    </div>
                </div>

                <div class="bh-items-head">Items</div>

                <div class="bh-table-wrap">
                    <p-table styleClass="p-datatable-striped bh-table" [autoLayout]="true"
                        [value]="item1.packageDetails" responsiveLayout="scroll" rowHover="true">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Description</th>
                                <th style="text-align: center">Qty</th>
                                <th style="text-align: right">Cost</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-item1>
                            <tr>
                                <td>{{ getWordsWithSpace(item1.title) }}</td>
                                <td style="text-align: center">{{ item1.quantity }}</td>
                                <td style="text-align: right">{{ item1.subTotalCost | currency | currencySpacing }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>

                <div class="bh-summary">
                    <div class="bh-summary-row">
                        <span>Sub-Total</span>
                        <span>{{ item1.invoiceSubtotal | currency | currencySpacing }}</span>
                    </div>
                    <div class="bh-summary-row">
                        <span>Discount</span>
                        <span>{{ item1.totalDiscountAmount | currency | currencySpacing }}</span>
                    </div>
                    <div class="bh-summary-row">
                        <span>Tax</span>
                        <span>{{ item1.totalTaxAmount | currency | currencySpacing }}</span>
                    </div>
                    <div class="bh-summary-row bh-summary-row--total">
                        <span>Total</span>
                        <span>{{ item1.grandTotal | currency | currencySpacing }}</span>
                    </div>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>

    <div class="bh-empty" *ngIf="!loadingContent && dataList.length === 0">
        <i class="pi pi-inbox"></i>
        <span>No billing history found.</span>
    </div>
</div>
